export default {
	"standard": "ТЭИ - Базовый отчет",
	"management": "ТЭИ - Управленческий потенциал",
	"full": "ТЭИ - Экспертный отчет",
	"empty": "Для исследования",
	"references": "Эталонный профиль",
	"trajectory": "Траектории"
}